export default __webpack_public_path__ + "static/media/authorbg05.d4571ad9.jpg";